export enum DeliveryStatuses {
  Received = 'received',
  InProgress = 'in_progress',
  DriverOnTheWay = 'DriverOnTheWay',
  ReadyForPickup = 'ready_for_pickup',
  DeliveryInProgress = 'DeliveryInProgress',
  Delivered = 'Delivered',
  Canceled = 'Canceled',
}
